import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import {
  getApprovalByType,
  hasSign,
  renderDate,
  renderTime,
  renderSign
} from './utils/PtwCommonUtils.tsx';

interface IProps {
  formCode?: string;
  itemData?: any;
}

const View = (props: IProps) => {
  const approvalList = props.itemData?.approvalMVOList;
  const issuePerforming = getApprovalByType(approvalList, 'ISSUE', 1);
  const issueCoordinator = getApprovalByType(approvalList, 'ISSUE', 2);
  const issueDiscipline = getApprovalByType(approvalList, 'ISSUE', 3);
  const issueConstruction = getApprovalByType(approvalList, 'ISSUE', 4);
  const closingPerforming = getApprovalByType(approvalList, 'CLOSURE', 1);
  const closingDiscipline = getApprovalByType(approvalList, 'CLOSURE', 2);
  const closingPtwCoordinator = getApprovalByType(approvalList, 'CLOSURE', 3);

  return (
    <div>
      <table className={'preview-table preview-bottom-border-bold'}>
        <colgroup>
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
        </colgroup>
        <tbody>
          <tr>
            <th rowSpan={2} className={'saf-bg-white'}>
              APPROVAL/
              <br />
              CONFIRMATION
            </th>
            <th colSpan={2}>PERFORMING AUTHORITY</th>
            <th colSpan={2}>Area Authority</th>
            <th colSpan={2}>SE&A Area Lead HSSE</th>
            <th colSpan={2}>SE&A PTW Coordinator</th>
          </tr>
          <tr>
            <th>DATE</th>
            <th>TIME</th>
            <th>DATE</th>
            <th>TIME</th>
            <th>DATE</th>
            <th>TIME</th>
            <th>DATE</th>
            <th>TIME</th>
          </tr>
          <tr>
            <th rowSpan={3} className={'saf-bg-white'}>
              Open
            </th>
            <td className="saf-td-center" style={{ height: '40px' }}>
              {hasSign(issuePerforming) ? renderDate(issuePerforming) : ''}
            </td>
            <td className="saf-td-center">
              {hasSign(issuePerforming) ? renderTime(issuePerforming) : ''}
            </td>
            <td className="saf-td-center">
              {hasSign(issueCoordinator) ? renderDate(issueCoordinator) : ''}
            </td>
            <td className="saf-td-center">
              {hasSign(issueCoordinator) ? renderTime(issueCoordinator) : ''}
            </td>
            <td className="saf-td-center">
              {hasSign(issueDiscipline) ? renderDate(issueDiscipline) : ''}
            </td>
            <td className="saf-td-center">
              {hasSign(issueDiscipline) ? renderTime(issueDiscipline) : ''}
            </td>
            <td className="saf-td-center">
              {hasSign(issueConstruction) ? renderDate(issueConstruction) : ''}
            </td>
            <td className="saf-td-center">
              {hasSign(issueConstruction) ? renderTime(issueConstruction) : ''}
            </td>
          </tr>
          <tr>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
          </tr>
          <tr>
            <td className="saf-td-center" style={{ height: '40px' }}>
              {hasSign(issuePerforming) ? issuePerforming.userNm : ''}
            </td>
            <td className="saf-td-center">{renderSign(issuePerforming)}</td>
            <td className="saf-td-center">
              {hasSign(issueCoordinator) ? issueCoordinator.userNm : ''}
            </td>
            <td className="saf-td-center">{renderSign(issueCoordinator)}</td>
            <td className="saf-td-center">
              {hasSign(issueDiscipline) ? issueDiscipline.userNm : ''}
            </td>
            <td className="saf-td-center">{renderSign(issueDiscipline)}</td>
            <td className="saf-td-center">
              {hasSign(issueConstruction) ? issueConstruction.userNm : ''}
            </td>
            <td className="saf-td-center">{renderSign(issueConstruction)}</td>
          </tr>
        </tbody>
      </table>
      <table className={'preview-table preview-bottom-border-bold'}>
        <colgroup>
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
        </colgroup>
        <tbody>
          <tr>
            <th rowSpan={2} className={'saf-bg-white'}>
              APPROVAL/
              <br />
              CONFIRMATION
            </th>
            <th colSpan={2}>PERFORMING AUTHORITY</th>
            <th colSpan={2}>Area Authority</th>
            <th colSpan={2}>SE&A Area Lead HSSE</th>
            <td colSpan={2} rowSpan={5}></td>
          </tr>
          <tr>
            <th>DATE</th>
            <th>TIME</th>
            <th>DATE</th>
            <th>TIME</th>
            <th>DATE</th>
            <th>TIME</th>
          </tr>
          <tr>
            <th rowSpan={3} className={'saf-bg-white'}>
              Close
            </th>
            <td className={'saf-td-center'} style={{ height: '40px', backgroundColor: '#E2EFDA' }}>
              {hasSign(closingPerforming) ? renderDate(closingPerforming) : ''}
            </td>
            <td className={'saf-td-center'} style={{ backgroundColor: '#E2EFDA' }}>
              {hasSign(closingPerforming) ? renderTime(closingPerforming) : ''}
            </td>
            <td className={'saf-td-center'} style={{ backgroundColor: '#E2EFDA' }}>
              {hasSign(closingDiscipline) ? renderDate(closingDiscipline) : ''}
            </td>
            <td className={'saf-td-center'} style={{ backgroundColor: '#E2EFDA' }}>
              {hasSign(closingDiscipline) ? renderTime(closingDiscipline) : ''}
            </td>
            <td className={'saf-td-center'} style={{ backgroundColor: '#E2EFDA' }}>
              {hasSign(closingPtwCoordinator) ? renderDate(closingPtwCoordinator) : ''}
            </td>
            <td className={'saf-td-center'} style={{ backgroundColor: '#E2EFDA' }}>
              {hasSign(closingPtwCoordinator) ? renderTime(closingPtwCoordinator) : ''}
            </td>
          </tr>
          <tr>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
            <th>NAME</th>
            <th>SIGN</th>
          </tr>
          <tr>
            <td className={'saf-td-center'} style={{ height: '40px', backgroundColor: '#E2EFDA' }}>
              {hasSign(closingPerforming) ? closingPerforming.userNm : ''}
            </td>
            <td className={'saf-td-center'} style={{ backgroundColor: '#E2EFDA' }}>
              {renderSign(closingPerforming)}
            </td>
            <td className={'saf-td-center'} style={{ backgroundColor: '#E2EFDA' }}>
              {hasSign(closingDiscipline) ? closingDiscipline.userNm : ''}
            </td>
            <td className={'saf-td-center'} style={{ backgroundColor: '#E2EFDA' }}>
              {renderSign(closingDiscipline)}
            </td>
            <td className={'saf-td-center'} style={{ backgroundColor: '#E2EFDA' }}>
              {hasSign(closingPtwCoordinator) ? closingPtwCoordinator.userNm : ''}
            </td>
            <td className={'saf-td-center'} style={{ backgroundColor: '#E2EFDA' }}>
              {renderSign(closingPtwCoordinator)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default View;
